import React from 'react';
import { Box } from '@mui/material';
import VehicleDetails from './VehicleDetails';
import EquipmentDetails from './EquipmentDetails';
import IndividualVehicleDetails from './IndividualVehicleDetails';
import Documents from './Documents';
import Comments from './Comments';

import styles from './procurementOrderContent.style';

const ProcurementOrderContent = ({
  index,
  orderId,
  documents,
  onDeleteFile,
  onGetDocuments,
  disabled,
  comments,
  onGetComments,
  isLocal,
}) => {
  return (
    <Box sx={styles.wrapper}>
      <VehicleDetails index={index} />
      <EquipmentDetails index={index} />
      <IndividualVehicleDetails index={index} />
      {!isLocal && (
        <Documents
          index={index}
          orderId={orderId}
          documents={documents}
          onDeleteFile={onDeleteFile}
          onGetDocuments={onGetDocuments}
          disabled={disabled}
        />
      )}
      {!isLocal && (
        <Comments
          index={index}
          orderId={orderId}
          comments={comments}
          onGetComments={onGetComments}
        />
      )}
    </Box>
  );
};

export default ProcurementOrderContent;
